import Big from 'big.js';
export const ACCOUNTING_FIELDS = Object.freeze(['installFee', 'leakageDeduction', 'insuranceDeduction', 'regionalSubsidy', 'specialSubsidy', 'monthlySubsidy']);
const DEDUCTION_FIELDS = new Set(['leakageDeduction', 'insuranceDeduction']);
export function accountingFee(row, big = Big) {
  return ACCOUNTING_FIELDS.reduce((sum, key) => {
    const amount = row[key] == null || row[key] === '' ? 0 : row[key];
    return DEDUCTION_FIELDS.has(key) ? sum.minus(amount) : sum.plus(amount);
  }, big(0)).toString();
}
